import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class AppRouteError extends Component {
    static propTypes = {
        location: PropTypes.object.isRequired,
        children: PropTypes.any
    }

    state = {
        isError: false
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.location !== nextProps.location || this.state.isError !== nextState.isError) {
            return true;
        }

        return false;
    }

    componentDidUpdate(prevProps) {
        if (this.state.isError && this.props.location !== prevProps.location) {
            this.setState({
                isError: false
            });
        }
    }

    componentDidCatch(error, info) {
        console.error(error);
        console.info(info);

        this.setState({
            isError: true
        });
    }

    render() {
        if (this.state.isError) {
            return (
                <main className='page-wrap'>
                    <div>
                        <h2>
                            Oops, une erreur est survenue.
                        </h2>
                    </div>
                </main>
            );
        }

        return this.props.children;
    }
}
